<hw-page-header header="term.cs-03.header" class="page-header" (onBack)="goBack()">
  <div class="content float-right">
    <button class="button" [routerLink]="['/codesystems/edit', codeSystem?.id]" nz-button nzType="secondary">
      {{ 'core.btn.edit' | translate }}
    </button>
    <a nz-dropdown class="dropdown-btn-container" [nzDropdownMenu]="dropdownMenu" [nzPlacement]="'bottomRight'">
      <button class="dropdown-btn dropdown-btn--default" title="More" type="button" nz-button nzType="icon" nz-dropdown>
        <i class="material-icons">more_horiz</i>
      </button>
    </a>
    <nz-dropdown-menu #dropdownMenu>
      <ul nz-menu>
        <li nz-menu-item (click)="exportCodesystem(true)">
          <a>
            <i class="dropdown-menu-icon" nz-icon nzType="download" nzTheme="outline"></i>
            {{ 'term.cs-03.button.export.full-json' | translate }}
          </a>
        </li>
        <li nz-menu-item (click)="exportCodesystem(false)">
          <a>
            <i class="dropdown-menu-icon" nz-icon nzType="download" nzTheme="outline"></i>
            {{ 'term.cs-03.button.export.mini-json' | translate }}
          </a>
        </li>
        <li nz-menu-item (click)="exportConcepts()">
          <a>
            <i class="dropdown-menu-icon" nz-icon nzType="download" nzTheme="outline"></i>
            {{ 'term.cs-03.button.export.concepts-csv' | translate }}
          </a>
        </li>
        <li nz-menu-item (click)="touchImportConceptsInput()">
          <a>
            <i class="dropdown-menu-icon" nz-icon nzType="upload" nzTheme="outline"></i>
            {{ 'term.cs-03.button.import' | translate }}
          </a>
        </li>
        <li nz-menu-item (click)="importEsthifConcepts()" *ngIf="codeSystem?.url">
          <a>
            <i class="dropdown-menu-icon" nz-icon nzType="upload" nzTheme="outline"></i>
            {{ 'term.cs-03.button.esthif-import' | translate }}
          </a>
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</hw-page-header>

<nz-content class="main" *ngIf="codeSystem">
  <hw-form-row>
    <hw-form-item *hwFormCol label="term.cs-03.id">
      {{ codeSystem.id }}
    </hw-form-item>
  </hw-form-row>
  <hw-form-row>
    <hw-form-item *hwFormCol label="term.cs-03.name">
      {{ codeSystem.names | localName }}
    </hw-form-item>
  </hw-form-row>
  <hw-form-row>
    <hw-form-item *hwFormCol label="term.cs-03.description">
      {{ codeSystem.title | localName }}
    </hw-form-item>
  </hw-form-row>
  <hw-form-row>
    <hw-form-item *hwFormCol label="term.cs-03.url">
      {{ codeSystem.url | localName }}
    </hw-form-item>
  </hw-form-row>

  <hw-table header="term.cs-03.concepts.title">
    <div headerContent>
      <input
        nz-input
        name="filter"
        [(ngModel)]="search"
        placeholder="{{ 'term.cs-03.concepts.quicksearch' | translate }}"
        style="width: 300px" />
      <button
        class="button"
        [routerLink]="['/codesystems', codeSystem.id, 'concepts', 'add']"
        nz-button
        nzType="primary">
        {{ 'term.cs-03.button.add-concept' | translate }}
      </button>
    </div>
    <nz-table
      #nzTable
      [nzData]="codeSystem.concepts | textSearch : { '*': search }"
      nzSize="small"
      nzFrontPagination="false"
      nzShowPagination="false">
      <thead>
        <tr>
          <th>{{ 'term.cs-03.concepts.id' | translate }}</th>
          <th>{{ 'term.cs-03.concepts.names' | translate }}</th>
          <th *ngFor="let attr of codeSystem.attributes | slice : maxAttributes : 0">
            {{ attr.names | localName : attr.id }}
          </th>
          <th *ngIf="validFromVisible">{{ 'term.cs-03.concepts.valid-from' | translate }}</th>
          <th *ngIf="validToVisible">{{ 'term.cs-03.concepts.valid-to' | translate }}</th>
          <th nzShowExpand *ngIf="codeSystem.attributes.length > maxAttributes"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ng-template ngFor let-data [ngForOf]="nzTable.data | nzTree">
          <ng-template ngFor let-node [ngForOf]="data.branch">
            <tr *ngIf="!node.parent || node.parent.expand">
              <td
                [nzIndentSize]="node.level * 20"
                [nzShowExpand]="!!node.children"
                [(nzExpand)]="node.expand"
                (nzExpandChange)="node.toggleExpand($event)">
                <a [routerLink]="['/codesystems', codeSystem.id, 'concepts', 'edit', node.item.id]">
                  {{ node.item.code }}
                </a>
              </td>
              <td>{{ node.item.names | localName }}</td>
              <td *ngFor="let attr of codeSystem.attributes | slice : maxAttributes : 0">
                {{ formatAttributeValue(attr.id, node.item) }}
              </td>
              <td *ngIf="validFromVisible">{{ node.item.valid?.lower | localDate }}</td>
              <td *ngIf="validToVisible">{{ node.item.valid?.upper | localDate }}</td>
              <td nzShowExpand [(nzExpand)]="node.attrExpand" *ngIf="codeSystem.attributes.length > maxAttributes"></td>
              <td>
                <a (click)="deleteConcept(node.item.id)">{{ 'term.cs-03.delete' | translate }}</a>
              </td>
            </tr>
            <tr [nzExpand]="node.attrExpand" *ngIf="codeSystem.attributes.length > maxAttributes">
              <td></td>
              <td colspan="99">
                <p *ngFor="let attr of codeSystem.attributes">
                  <strong>{{ attr.names | localName : attr.id }}: </strong>
                  {{ formatAttributeValue(attr.id, node.item) }}
                </p>
              </td>
            </tr>
          </ng-template>
        </ng-template>
      </tbody>
    </nz-table>
  </hw-table>
  <input #importConcepts [hidden]="true" type="file" (change)="importCsConcepts($event)" />
</nz-content>
